import React from 'react';

const Arkansas = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Arkansas Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Caveat emptor; no disclosure form required.</li>
      </ol>
      <li>Property Disclosures: Not mandatory by state law but recommended.</li>
      <li>
        Attorney Involvement: Optional, but many use an attorney for the title
        examination.
      </li>
      <li>
        <span
          className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
          onClick={() => {
            window.open(
              'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
              '_blank'
            );
          }}
        >
          Lead-Based Paint Disclosure{' '}
        </span>
        – Only for residences that were built before 1978. This information
        should be available at the County’s Revenue Office.
      </li>
      <li>
        <span
          className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
          onClick={() => {
            window.open(
              'https://eforms.com/images/2018/07/Arkansas-Sellers-Property-Disclosure-Form.pdf',
              '_blank'
            );
          }}
        >
          Sellers Disclosure Form{' '}
        </span>
        – Not required according to law.
      </li>
    </div>
  );
};

export default Arkansas;
